// extracted by mini-css-extract-plugin
export var actionButton = "_pb-0";
export var actionMenuContainer = "_pb-i";
export var bubble = "_pb-2";
export var bubbleActionMenu = "_pb-j";
export var bubbleContext = "_pb-6";
export var bubbleItems = "_pb-7";
export var customer = "_pb-3";
export var divider = "_pb-8";
export var fileList = "_pb-9";
export var hiddenComment = "_pb-o";
export var infoAbove = "_pb-a";
export var internal = "_pb-4";
export var lightActionButton = "_pb-1";
export var link = "_pb-b";
export var merchant = "_pb-5";
export var message = "_pb-c";
export var profilePicture = "_pb-e";
export var quillToolbarContainer = "_pb-f";
export var senderDate = "_pb-g";
export var senderDateCustomer = "_pb-h";
export var senderName = "_pb-d";
export var time = "_pb-k";
export var uploadedImage = "_pb-l";
export var username = "_pb-m";
export var xsmall = "_pb-n";